<!-- Footer -->
<footer class="page-footer" style="background-color: #e3f2fd;text-align: end;">

  <!-- Footer Links -->
  <label style="padding-right: 20px;">Version: 2.4.14</label>
  <button *ngIf="isLoggedIn()" class="btn btn-primary" style="margin-top: 10px;" (click)="Logout()">Logout</button>
  <!-- Footer Links -->

</footer>
<!-- Footer -->
